import { Link } from "react-router-dom";
import { rankingComics } from "@/mocks/comics";
import { useState } from "react";

type RankingTab = "popular" | "newest" | "completed";

const tabs: { key: RankingTab; label: string }[] = [
  { key: "popular", label: "人气榜" },
  { key: "newest", label: "新作榜" },
  { key: "completed", label: "完结榜" },
];

export default function RankingList() {
  const [activeTab, setActiveTab] = useState<RankingTab>("popular");

  const displayComics = rankingComics.slice(0, 10);

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1 font-label">
              热门漫画排行推荐
            </p>
          </div>
          <div className="flex items-center bg-background-100 rounded-full p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-1.5 rounded-full text-sm font-label transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {displayComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div
                className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold font-label ${
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </div>
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 font-label">
                  {comic.author}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-[10px] text-accent-600 font-label">
                    <i className="ri-star-fill text-[10px] mr-0.5"></i>
                    {comic.rating}
                  </span>
                  <span className="text-[10px] text-foreground-400 font-label">
                    {comic.status}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-xs text-foreground-400 font-label">
                  {(comic.views / 10000).toFixed(0)}万
                </span>
                <p className="text-[10px] text-foreground-400 font-label">人气</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}